import React from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import {
  Grid,
  Row,
  Col,
  Tab,
  Button,
  Badge
} from 'react-bootstrap';

import {
  myTeamsGet,
  pollMyTeamsGet,
} from '../util/thunks';
import PlayerCard from './ui/PlayerCard';
import ZeroState from './ui/ZeroState';
import ColoredNavItem from './ui/ColoredNavItem';
import CardsNav from './ui/CardsNav';

class MyTeamsList extends React.Component {

  componentWillMount() {
    this.props.myTeamsGet();

    this.interval = setInterval(() => {
      this.props.pollMyTeamsGet();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getTeamColor(teamName) {
    let teamKey = teamName.toLowerCase().replace(' ', '-');
    return `#${this.props.myTeams.colors[teamKey]}`;
  }

  render() {
    return (
      <Grid>
        <Row>

          <Tab.Container id="myteams" defaultActiveKey="all">
            <div>

              <CardsNav bsStyle="pills">
                <ColoredNavItem
                  eventKey="all"
                  color="gray">All <Badge>{this.props.myTeams.tokens.length}</Badge></ColoredNavItem>
                {Object.keys(this.props.myTeams.tokensByTeam).map(teamName =>
                  <ColoredNavItem
                    eventKey={teamName}
                    color={this.getTeamColor(teamName)}
                    key={teamName}>{teamName}<Badge>{this.props.myTeams.uniqueCountByTeam[teamName]} / 32</Badge></ColoredNavItem>
                )}
              </CardsNav>

              <Tab.Content animation={false}>

                <Tab.Pane eventKey="all">
                  {this.props.myTeams.tokens.map((token, i) =>
                    <Col xs={6} sm={4} md={3} key={i}>
                      <PlayerCard player={token}>
                        <span style={{display: 'block', width: '100%', textAlign: 'center'}} role="img" aria-label="soccer">⚽</span>
                      </PlayerCard>
                    </Col>
                  )}
                </Tab.Pane>

                {Object.keys(this.props.myTeams.tokensByTeam).map(teamName =>
                  <Tab.Pane eventKey={teamName} key={teamName}>
                    {this.props.myTeams.tokensByTeam[teamName].map((token, i) =>
                      <Col xs={6} sm={4} md={3} key={i}>
                        <PlayerCard player={token}>
                          <span style={{display: 'block', width: '100%', textAlign: 'center'}} role="img" aria-label="soccer">⚽</span>
                        </PlayerCard>
                      </Col>
                    )}
                  </Tab.Pane>
                )}

              </Tab.Content>

            </div>
          </Tab.Container>

          {this.props.myTeams.tokens.length === 0 &&
            <ZeroState bsSize="large">
              <p>Looks like you don't have any cards yet!</p>
              <p>Bid or barter for your first card:</p>

              <LinkContainer to="/drops">
                <Button>New Cards</Button>
              </LinkContainer>
              <Button href="https://opensea.io/assets" target="_blank" bsStyle="link">OpenSea Marketplace</Button>
            </ZeroState>
          }

        </Row>
      </Grid>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    myTeams: state.myTeams,
  };
};

const mapDispatchToProps = (dispatch) => ({

  myTeamsGet: () => {
    return dispatch(myTeamsGet());
  },

  pollMyTeamsGet: () => {
    return dispatch(pollMyTeamsGet());
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(MyTeamsList);



// WEBPACK FOOTER //
// ./src/components/MyTeamsList.js